"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonGroup = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledButtonGroup = styled_components_1.default.div `
    display: flex;

    & > * {
        border-radius: 0;

        &:first-child {
            border-radius: var(--ds-border-radius) 0 0 var(--ds-border-radius);
        }
        &:last-child {
            border-radius: 0 var(--ds-border-radius) var(--ds-border-radius) 0;
        }
        &:not(:first-child) {
            // This will cover the box shadow from neighbouring button
            margin-left: -1px;
        }
        &:not(:first-child):not(:last-child) {
            border-radius: 0;
        }

        // When it is the only button in the group we need border radius on all corners
        &:first-child:last-child {
            border-radius: var(--ds-border-radius);
            margin-left: 0;
        }

        &:focus,
        &:focus-within {
            z-index: 9999;
        }
    }

    // Duplicating styles for buttons with tooltip span wrapper
    & > span {
        &:first-child button,
        &:first-child a {
            border-radius: var(--ds-border-radius) 0 0 var(--ds-border-radius);
        }
        &:last-child button,
        &:last-child a {
            border-radius: 0 var(--ds-border-radius) var(--ds-border-radius) 0;
        }
        &:not(:last-child) button,
        &:not(:last-child) a {
            border-right: 0;
        }
        &:not(:first-child):not(:last-child) button,
        &:not(:first-child):not(:last-child) a {
            border-radius: 0;
        }

        // When it is the only button in the group we need border radius on all corners
        &:first-child:last-child button,
        &:first-child:last-child a {
            border-radius: var(--ds-border-radius);
        }
    }
`;
//# sourceMappingURL=ButtonGroup.styles.js.map